/** Terms and conditions (Ley 24.240 de Defensa del Consumidor). */
import { CONSUMER_URL, type InfoDoc } from "../types";

export const terms: InfoDoc = {
  es: {
    title: "Términos y condiciones",
    intro:
      "Estos términos regulan el uso de pokefans.fun y las compras que hagas en la tienda. Al usar el sitio o crear una cuenta los aceptás. Si no estás de acuerdo, no uses el sitio.",
    sections: [
      {
        title: "1. Quiénes somos",
        paragraphs: [
          "pokefans.fun es una tienda online de cartas y productos de Pokémon TCG con base en Argentina. Para cualquier consulta, reclamo o pedido escribinos a {email}.",
        ],
      },
      {
        title: "2. Tu cuenta",
        paragraphs: [
          "Podés crear una cuenta con tu email y una contraseña o ingresar con Google. Los datos que cargues tienen que ser verdaderos y estar actualizados.",
          "Sos responsable de cuidar tu contraseña y de lo que se haga desde tu cuenta. Si creés que alguien más la está usando, avisanos.",
          "Podemos suspender o cerrar cuentas usadas para fraude, abuso del sitio o incumplimiento de estos términos.",
          "Para comprar tenés que ser mayor de 18 años o contar con la autorización de tu madre, padre o tutor.",
        ],
      },
      {
        title: "3. Productos",
        paragraphs: [
          "Vendemos cartas originales y productos sellados de fábrica. En cada carta indicamos el estado (NM, LP, MP, HP o dañada), la terminación (normal, holo, reverse holo o primera edición) y el idioma.",
          "Algunas fotos son imágenes de referencia del catálogo y no de la unidad exacta que vas a recibir. El estado indicado en la publicación es el que vale.",
          "El stock es limitado y se actualiza en tiempo real, pero puede haber diferencias puntuales. Si un producto que compraste no está disponible, te avisamos y te devolvemos el total pagado.",
        ],
      },
      {
        title: "4. Precios y pagos",
        paragraphs: [
          "Los precios se publican en dólares estadounidenses (US$). El precio en pesos que ves al elegir AR$ es informativo: se calcula con la cotización del dólar blue más un 5%, que se actualiza todos los días a las 21 h.",
          "Si pagás con Mercado Pago, se cobra en pesos con la cotización vigente al momento de iniciar el pago. Con tarjeta internacional o PayPal se cobra en dólares.",
          "Los pagos los procesan Mercado Pago, Stripe o PayPal; nosotros no vemos ni guardamos los datos de tu tarjeta. También podés pagar por transferencia bancaria (en pesos) o en cripto (USDT, en dólares), con el descuento que se muestra en el checkout: el pedido queda reservado 2 horas y se confirma cuando verificamos el comprobante que nos mandás.",
          "Si un precio publicado tiene un error evidente, podemos cancelar el pedido y devolverte lo pagado antes de enviarlo.",
        ],
      },
      {
        title: "5. Pedidos",
        paragraphs: [
          "Cuando confirmás un pedido reservamos los productos por un tiempo limitado. Si el pago no se acredita en ese plazo, el pedido se cancela y los productos vuelven a estar disponibles.",
          "Te enviamos por email la confirmación del pedido y los avisos de pago y envío.",
        ],
      },
      {
        title: "6. Entrega",
        paragraphs: [
          "Enviamos los pedidos a domicilio. A CABA y al Gran Buenos Aires lo despachamos dentro de las 48 horas de acreditado el pago, con un costo fijo por zona que se muestra y se paga en el checkout. Al resto del país, el envío se coordina por WhatsApp. Los plazos del correo son estimados y no dependen de nosotros. Detalles en [[/envios|envíos]].",
          "Al recibir el paquete revisá que esté cerrado y en buen estado. Si llegó dañado o incompleto, avisanos lo antes posible con fotos.",
        ],
      },
      {
        title: "7. Derecho de arrepentimiento y devoluciones",
        paragraphs: [
          "Como compra a distancia, tenés derecho a arrepentirte dentro de los 10 días corridos desde que recibís el producto, sin dar explicaciones (artículo 34 de la Ley 24.240). Para hacerlo usá el [[/arrepentimiento|botón de arrepentimiento]] o escribinos a {email} con el número de pedido.",
          "Los gastos de devolución corren por nuestra cuenta y te reintegramos lo pagado por el mismo medio de pago. Te pedimos que devuelvas el producto como lo recibiste; si no podés por algo que hiciste vos (por ejemplo, abriste un producto sellado), igual podés arrepentirte, pero nos pagás su valor de mercado a ese momento, con un tope en lo que pagaste (artículo 1114 del Código Civil y Comercial).",
          "Si un producto no coincide con lo publicado o tiene un defecto, lo cambiamos o te devolvemos el dinero, según prefieras (artículo 17 de la Ley 24.240). Tenés además la garantía legal por defectos: 6 meses para productos nuevos (sellados) y 3 meses para usados (cartas sueltas) (artículo 11). Los detalles están en la [[/reembolsos|política de reembolsos]].",
        ],
      },
      {
        title: "8. Propiedad intelectual",
        paragraphs: [
          "Pokémon y los nombres, imágenes y logos relacionados son marcas registradas de Nintendo, Creatures Inc., GAME FREAK inc. y The Pokémon Company. pokefans.fun es una tienda independiente y no está afiliada ni patrocinada por esas empresas.",
          "El diseño, los textos y el código del sitio son de pokefans.fun. No podés copiarlos ni usarlos con fines comerciales sin nuestra autorización.",
        ],
      },
      {
        title: "9. Uso del sitio",
        paragraphs: [
          "No está permitido usar el sitio para actividades ilegales, intentar acceder a cuentas o sistemas ajenos, ni extraer datos del catálogo en forma automatizada.",
          "Hacemos lo posible para que el sitio funcione sin interrupciones, pero puede haber cortes o errores. No respondemos por daños indirectos derivados de esas fallas, sin perjuicio de los derechos que te da la ley como consumidor.",
        ],
      },
      {
        title: "10. Cambios en estos términos",
        paragraphs: [
          "Podemos actualizar estos términos. La versión vigente es la publicada en esta página, con la fecha de su última actualización. Los cambios no afectan a los pedidos ya confirmados.",
        ],
      },
      {
        title: "11. Ley aplicable y reclamos",
        paragraphs: [
          "Estos términos se rigen por las leyes de la República Argentina. Ante cualquier conflicto son competentes los tribunales del domicilio del consumidor.",
          `Defensa de las y los consumidores: para reclamos podés ingresar en ${CONSUMER_URL}.`,
        ],
      },
    ],
  },
  en: {
    title: "Terms and conditions",
    intro:
      "These terms govern your use of pokefans.fun and the purchases you make in the store. By using the site or creating an account you accept them. If you don't agree, please don't use the site.",
    sections: [
      {
        title: "1. Who we are",
        paragraphs: [
          "pokefans.fun is an online store for Pokémon TCG cards and products based in Argentina. For any question, complaint or request, write to {email}.",
        ],
      },
      {
        title: "2. Your account",
        paragraphs: [
          "You can create an account with your email and a password, or sign in with Google. The information you provide must be true and up to date.",
          "You are responsible for keeping your password safe and for what is done from your account. If you think someone else is using it, let us know.",
          "We may suspend or close accounts used for fraud, abuse of the site or breach of these terms.",
          "To buy you must be 18 or older, or have the permission of a parent or guardian.",
        ],
      },
      {
        title: "3. Products",
        paragraphs: [
          "We sell genuine cards and factory-sealed products. For each card we state its condition (NM, LP, MP, HP or damaged), finish (normal, holo, reverse holo or first edition) and language.",
          "Some photos are catalog reference images, not the exact unit you will receive. The condition stated in the listing is what counts.",
          "Stock is limited and updated in real time, but occasional differences may happen. If a product you bought is not available, we will tell you and refund the full amount paid.",
        ],
      },
      {
        title: "4. Prices and payments",
        paragraphs: [
          "Prices are listed in US dollars (US$). The peso price shown when you choose AR$ is for reference: it uses the dólar blue rate plus 5%, updated every day at 9 pm (Argentina time).",
          "If you pay with Mercado Pago you are charged in pesos at the rate in force when the payment starts. International cards and PayPal are charged in US dollars.",
          "Payments are processed by Mercado Pago, Stripe or PayPal; we never see or store your card details. You can also pay by bank transfer (pesos) or crypto (USDT, in dollars), with the discount shown at checkout: the order is held for 2 hours and confirmed once we check the receipt you send us.",
          "If a listed price contains an obvious error, we may cancel the order and refund you before shipping it.",
        ],
      },
      {
        title: "5. Orders",
        paragraphs: [
          "When you confirm an order we hold the products for a limited time. If the payment is not confirmed within that time, the order is cancelled and the products become available again.",
          "We email you the order confirmation and the payment and shipping updates.",
        ],
      },
      {
        title: "6. Delivery",
        paragraphs: [
          "We deliver orders to your door. To Buenos Aires City and Greater Buenos Aires we dispatch within 48 hours of payment, at a fixed price per area shown and paid at checkout. Elsewhere, shipping is arranged on WhatsApp. Carrier times are estimates and outside our control. Details on [[/envios|shipping]].",
          "When you receive the parcel, check that it is sealed and in good condition. If it arrived damaged or incomplete, let us know as soon as possible with photos.",
        ],
      },
      {
        title: "7. Right of withdrawal and returns",
        paragraphs: [
          "As a distance purchase, you may withdraw within 10 calendar days of receiving the product, without giving a reason (article 34 of Argentine Law 24,240). To do so, use the [[/arrepentimiento|withdrawal button]] or write to {email} with your order number.",
          "We cover the return shipping and refund you through the same payment method. Please return the product as you received it; if you can't because of something you did (for example, you opened a sealed product), you can still withdraw, but you owe us its market value at that moment, capped at what you paid (article 1114 of the Argentine Civil and Commercial Code).",
          "If a product does not match its listing or is defective, we will replace it or refund you, as you prefer (article 17 of Law 24,240). You also have the legal warranty against defects: 6 months for new products (sealed) and 3 months for used ones (single cards) (article 11). See the [[/reembolsos|refund policy]] for details.",
        ],
      },
      {
        title: "8. Intellectual property",
        paragraphs: [
          "Pokémon and related names, images and logos are trademarks of Nintendo, Creatures Inc., GAME FREAK inc. and The Pokémon Company. pokefans.fun is an independent store and is not affiliated with or sponsored by them.",
          "The site's design, texts and code belong to pokefans.fun. You may not copy them or use them commercially without our permission.",
        ],
      },
      {
        title: "9. Use of the site",
        paragraphs: [
          "You may not use the site for illegal activities, try to access other people's accounts or our systems, or scrape the catalog automatically.",
          "We do our best to keep the site running, but outages or errors may happen. We are not liable for indirect damages caused by them, without prejudice to your statutory consumer rights.",
        ],
      },
      {
        title: "10. Changes to these terms",
        paragraphs: [
          "We may update these terms. The version in force is the one on this page, with its last updated date. Changes do not affect orders already confirmed.",
        ],
      },
      {
        title: "11. Governing law and complaints",
        paragraphs: [
          "These terms are governed by the laws of Argentina. Any dispute falls under the courts of the consumer's domicile.",
          `Consumer protection (Argentina): you can file complaints at ${CONSUMER_URL}.`,
        ],
      },
    ],
  },
};
